import React from 'react'
import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import { isPublicAssetFromLamyNetwork } from '@flatsy/utils/Functions/Assets'
import i18n from '@flatsy/utils/translations'

import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import LamyPrivacyNotice from 'src/utils/Lamy'

import FileProvider, { FileContext } from './Context'
import MainContainer from './MainContainer'
import MobileAddFileButton from './MobileAddFileButton'
import SideBar from './SideBar'
import { useStyles } from './Style'
import UploadModal from './UploadModal'

const Files: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const {
    application: { application },
    asset,
  } = useApplicationDetails()

  if (!asset || !application) {
    return <></>
  }

  return (
    <FileProvider>
      <FileContext.Consumer>
        {({ upload: { openModal } }) => (
          <>
            <MobileAddFileButton />
            <div className={classes.container}>
              <div className={classes.sidebar}>
                <SideBar />
              </div>
              <div className={classes.mainWrapper}>
                <MainContainer />
                <div className={classes.legal}>
                  <Body1 className={classes.legalContent}>
                    {i18n.t('the_requested_documents_comply_with_the_decree')}
                    <a
                      href="https://www.service-public.fr/particuliers/vosdroits/F1169"
                      target="_blank"
                      rel="noreferrer"
                      className={classes.link}
                    >
                      {i18n.t('decree_n_2015-1437_of_5_November_2015')}
                    </a>
                    {isPublicAssetFromLamyNetwork(asset) && (
                      <>
                        {' • '}
                        <LamyPrivacyNotice trigger="Pour plus d'informations sur la collecte et le traitement des données" />
                      </>
                    )}
                  </Body1>
                </div>
              </div>
            </div>
            <UploadModal open={openModal} />
          </>
        )}
      </FileContext.Consumer>
    </FileProvider>
  )
}

export default Files
